export const KASSA_SITE_LINK = 'https://kassa24.kz';
export const TYPES_OF_INCIDENTS = [
  { type: 1, title: 'Терминал зажевал купюру', bitrixId: 4760 },
  {
    type: 2,
    title: 'Терминал без сигнала, деньги приняты, оплата не поступила',
    bitrixId: 4762,
  },
  {
    type: 3,
    title: 'Терминал заблокирован, превышен суточный оборот',
    bitrixId: 4764,
  },
];

export const DEAL_CRM_PARAMS = {
  OPENED: 'Y',
  CATEGORY_ID: 60,
  IS_NEW: 'Y',
};
